<div class="flex items-center justify-center w-full h-full p-0" data-testid="root-container">
  <div class="border-0 w-full h-full flex flex-col p-2" data-testid="content">
    <div class="mb-[0.5px] border-0 flex flex-col h-full">
      <flx-ai-side-chat-history [messages]="messages()" style="max-height: calc(100vh - 235px)"
        data-testid="chat-history" />
    </div>

    @if (showUploadedImages()) {
    @for (image of images(); track image) {
    <div class="px-6 pt-2">
      <div
        class="flex flex-col rounded-lg p-2 absolute uploaded-file bg-black/70 gap-1 w-[112px] h-[142px] overflow-hidden"
        data-testid="uploaded-image">
        <div class="relative overflow-hidden rounded-lg">
          <p-image [src]="image.src$ | async" [alt]="image.name" class="w-[96px] h-[108px] object-cover" width="96px"
            preview="true" height="108px" imageClass="min-w-[96px] w-auto min-h-[108px] h-auto object-contain" />
          <button (click)="deleteFileFromContext(image.id)"
            class="absolute right-1 bottom-1 h-5 w-5 flex justify-center items-center rounded-[6px] bg-black cursor-pointer"
            data-testid="delete-uploaded-image-button">
            <flx-icon name="trash" class="w-3 h-3 text-red-500" />
          </button>
        </div>
        <div class="h-4 text-[10px] leading-[8px] text-white truncate grow-0" data-testid="uploaded-image-name">
          {{ image.name }}
        </div>
      </div>
    </div>
    }
    }

    @if (showUploadedBpmnFiles()) {
    @for (bpmn of bpmnFiles(); track bpmn) {
    <div class="px-6 pt-2">
      <div
        class="flex flex-col rounded-lg p-2 bg-black/70 absolute uploaded-file gap-1 w-[112px] h-[142px] overflow-hidden"
        data-testid="uploaded-bpmn">
        <div class="relative overflow-hidden rounded-lg">
          <p-image [alt]="bpmn.name" class="w-[96px] h-[108px]" src="./assets/bpmn_thumb_full.svg" width="96px"
            height="108px" imageClass="min-w-[96px] w-auto min-h-[108px] h-auto object-cover"
            data-testid="uploaded-bpmn-preview" />
          <button (click)="deleteFileFromContext(bpmn.id)"
            class="absolute right-1 bottom-1 h-5 w-5 flex justify-center items-center rounded-[6px] bg-black cursor-pointer"
            data-testid="delete-uploaded-bpmn-button">
            <flx-icon name="trash" class="w-3 h-3 text-red-500" />
          </button>
        </div>
        <div class="h-4 text-[10px] leading-[8px] text-white truncate grow-0" data-testid="uploaded-bpmn-name">
          {{ bpmn.name }}
        </div>
      </div>
    </div>
    }
    }

    @if (showChatTypeArea()) {
    <div [ngClass]="{
          'absolute bottom-0 right-0 [@media(min-width:1800px)]:w-1/5 [@media(min-width:1800px)]:max-w-calc(1/5-2px) max-w-1/4 w-1/4   min-w-[399px]  backdrop-blur-[2px] bg-gradient-to-t from-neutral-900/70 to-neutral-900/10':
            !sidePanelMode(),
          'w-full': sidePanelMode(),
        }" class="flex flex-col gap-1">
      <div class="flex justify-center items-center text-xs font-thin text-neutral-300 opacity-50 select-none mt-2">
        AI may generate results that need human review.
      </div>

      <div class="flex flex-col px-4 py-2 border-[0.5px] border-neutral-600 rounded-lg bg-black/40 mx-2 mt-1 mb-3"
        data-testid="chat-type-area-container">
        <flx-ai-side-type-area [showMentionButton]="true" [hints]="[
              'Ask me to explain or do something...',
              'Use @ to mention an agent...',
              'Describe the app you want to build...',
              'Create a plan for an AI Business Agent...',
            ]" tabIndex="2" data-testid="side-chat-type-area" />
      </div>
    </div>
    }
  </div>
</div>